import React from "react";

import { decryptPhone } from "../../Student/utils/encryptedPhone";

const useAgentRouteContext = (location) => {
  return React.useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlPhoneEncrypted = searchParams.get("phone");
    const decryptedPhone = urlPhoneEncrypted
      ? decryptPhone(urlPhoneEncrypted)
      : "";

    const state = location.state || {};

    return {
      stateAgentData: state.agentData || null,
      statePhone: state.phone || null,
      decryptedPhone,
    };
  }, [location.search, location.state]);
};

export default useAgentRouteContext;
